import {PIXI} from '@colonist/pixi'
import {UIGameEndTableView} from './GameEndTableView'
import {EndGameData, VictoryPointStateReader} from '@colonist/game-base-types'
import {EndGameStateUtils} from '@colonist/game-endgame-types'
import {EndGameState} from '@colonist/game-states'

export class GameEndStatsResourceStatsView extends UIGameEndTableView {
    constructor(x: number, y: number, w: number, h: number, container: PIXI.Container, columnWidth: number, rowHeight: number, endGameState: EndGameState) {
        super(x, y, w, h, container, columnWidth, rowHeight)
        const newResourceStats = endGameState.resourceStats
        const points: EndGameData[][] = []
        const players = EndGameStateUtils.getPlayersSortedByRank(endGameState.players)
        for(const player of players) {
            const data: EndGameData[] = []
            const playerVP = VictoryPointStateReader.totalPrivateVictoryPoints(player.victoryPoints)
            const playerResourceStats = newResourceStats[player.color]
            if(playerResourceStats === undefined) continue
            data.push({amount: playerVP, highest: false})
            data.push({amount: playerResourceStats.totalResourceIncome, highest: false})
            data.push({amount: playerResourceStats.totalResourceLoss, highest: false})
            data.push({amount: playerResourceStats.totalResourceScore, highest: false})
            data.push({amount: playerResourceStats.rollingIncome, highest: false})
            data.push({amount: playerResourceStats.robbingIncome, highest: false})
            data.push({amount: playerResourceStats.devCardIncome, highest: false})
            data.push({amount: playerResourceStats.tradeIncome, highest: false})
            data.push({amount: playerResourceStats.rollingLoss, highest: false})
            data.push({amount: playerResourceStats.robbingLoss, highest: false})
            data.push({amount: playerResourceStats.devCardLoss, highest: false})
            data.push({amount: playerResourceStats.tradeLoss, highest: false})
            data.push({amount: playerResourceStats.goldIncome, highest: false})
            points.push(data)
        }

        this.createPoints(points)
    }
}
